import { defaultTableRowRenderer } from 'react-virtualized';
import styles from 'styles/table.css';

export const DefaultRowRenderer = ({
  rowData,
  style,
  className,
  key,
  colorField,
  ...props
}) => {
  const cn = colorField
    ? `${className} ${styles.rowWithColors} ${styles[rowData[colorField]]}`
    : className;

  return defaultTableRowRenderer({
    ...props,
    key,
    rowData,
    className: cn,
    style,
  });
};



// WEBPACK FOOTER //
// ./src/views/components/Table/RowRenderers.jsx